import { createContext } from 'react';

import { IRxdbManager } from '../replication-v2/legacy/IRxdbManager';

type IUseRxDB = {
  db?: IRxdbManager;
};

export const RxDBContext = createContext<null | IUseRxDB>(null);
